import { ActivityEventRow, UserName } from "./ActivityEventRow";

import { Avatar } from "@/components/quick-access/Avatar";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useGetJobWithCompany } from "@/hooks/queries/useGetJobWithCompany";
import { useGetUser } from "@/hooks/queries/useGetUser";
import { activityTypography } from "@/lib/constants";
import type { CandidacyJobChange } from "@/types";

export const JobChangeEvent = ({
  candidateFullName,
  currentUserId,
  jobChange,
}: {
  candidateFullName: string;
  currentUserId: number;
  jobChange: CandidacyJobChange;
}) => {
  /* Database CRUD Operations */
  // Read
  const currentCompanyId = useCurrentCompanyId();
  const { data: user } = useGetUser({ userId: jobChange.userId });
  const { data: fromJob } = useGetJobWithCompany({
    companyId: currentCompanyId,
    jobId: jobChange.fromJobId,
  });
  const { data: toJob } = useGetJobWithCompany({
    companyId: currentCompanyId,
    jobId: jobChange.toJobId,
  });

  /* Helpers */
  const jobLabel = (job?: { company: { name: string }; title: string }) =>
    job ? `${job.title} - ${job.company.name}` : "another job";

  /* Render */
  const render = () => {
    return (
      <ActivityEventRow
        createdAt={jobChange.createdAt}
        icon={
          <Avatar
            initials={user ? `${user.firstName[0]}${user.lastName[0]}` : "?"}
          />
        }
      >
        <UserName currentUserId={currentUserId} user={user} /> moved{" "}
        <span className={activityTypography.emphasis}>{candidateFullName}</span>{" "}
        from{" "}
        <span className={activityTypography.emphasis}>{jobLabel(fromJob)}</span>{" "}
        to <span className={activityTypography.emphasis}>{jobLabel(toJob)}</span>
      </ActivityEventRow>
    );
  };

  return render();
};
